import { render, staticRenderFns } from "./TaxHistory.vue?vue&type=template&id=86ec6b46"
import script from "./TaxHistory.vue?vue&type=script&lang=js"
export * from "./TaxHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports